import { supabase } from '@/lib/supabase'

export type RewardsBingxDailyItem = {
  time_ms: number
  trading_volume_usdt: number
  commission_usdt: number
}

export type RewardsBingxDailyResponse = {
  ok: boolean
  linked: boolean
  account_id?: string
  cycle?: { id: string | null; period_start: string; period_end: string }
  totals?: { trading_volume_usdt: number; commission_usdt: number }
  items?: RewardsBingxDailyItem[]
  reason?: string
}

export async function fetchRewardsBingxUserDaily(params?: { accountId?: string; budgetMs?: number }): Promise<RewardsBingxDailyResponse> {
  const { data, error } = await supabase.functions.invoke('rewards-bingx-user-daily', {
    body: {
      account_id: params?.accountId || undefined,
      budget: params?.budgetMs || undefined,
    } as any,
  })
  if (error) throw error
  return (Array.isArray(data) ? (data as any)[0] : (data as any)) as RewardsBingxDailyResponse
}

